import * as React from 'react'

import SvgIcon from '@thg-commerce/gravity-icons/src/components/SvgIcon'
import { useTheme } from '@thg-commerce/gravity-patterns/theme'
import { spacing } from '@thg-commerce/gravity-theme'

import { FacilityGrid, FacilityGridItem } from './styles'

export enum FacilityIcon {
  YES = 'YES',
  NO = 'NO',
}

export interface StoreFacility {
  title: string
  icon: FacilityIcon
}

interface FacilitiesProps {
  storeFacility?: StoreFacility[]
}

export const Facilities = (props: FacilitiesProps) => {
  const theme = useTheme()
  return (
    <FacilityGrid rows={2} columns={2}>
      {props.storeFacility &&
        props.storeFacility.length > 0 &&
        props.storeFacility?.map((facility, index) => {
          const facilityStatus = facility.icon === FacilityIcon.YES
          const icon = facilityStatus
            ? theme.icons.tickCircle
            : theme.icons.crossCircle
          return (
            <FacilityGridItem key={`facility-${index}`} status={facilityStatus}>
              {icon?.svgPath && (
                <div
                  style={{
                    height: icon?.height,
                    width: icon?.width,
                    marginRight: '3px',
                    marginTop: '3px',
                  }}
                >
                  <SvgIcon
                    xmlns="http://www.w3.org/2000/svg"
                    height={icon?.height}
                    width={icon?.width}
                    viewBox={icon?.viewBox}
                  >
                    <path d={icon?.svgPath} />
                  </SvgIcon>
                </div>
              )}
              <span>{facility.title}</span>
            </FacilityGridItem>
          )
        })}
    </FacilityGrid>
  )
}
